import { render, staticRenderFns } from "./WorkDocsSchemeTypeModalForm.vue?vue&type=template&id=6f0f634c&scoped=true&"
import script from "./WorkDocsSchemeTypeModalForm.vue?vue&type=script&lang=js&"
export * from "./WorkDocsSchemeTypeModalForm.vue?vue&type=script&lang=js&"
import style0 from "./WorkDocsSchemeTypeModalForm.vue?vue&type=style&index=0&id=6f0f634c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0f634c",
  null
  
)

export default component.exports